import { useEffect } from "react";
import Button from "../components/ui/Button";
import Breadcrumbs from "../components/ui/Breadcrumbs";
import './Checkout.scss';
import './ThankYou.scss';
import { useDispatch, useSelector } from "react-redux";
import useLoadDBImage from "../hooks/useLoadDBImage";
import { setCustomizerStep } from "../store/customizerSlice";
import { resetVisitSession } from "../utils/eventsTracking/trackCustomEvent";
import { useAppNavigate } from "../hooks/useAppNavigate";

const breadcrumbs = [
  { label: "Customizer", link: "/customizer" },
  { label: "Checkout", link: "/checkout" },
];

const ThankYou = ({ isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useAppNavigate();
  const orderDetails = useSelector((state) => state.checkout.orderDetails);

  useEffect(() => {
    dispatch(setCustomizerStep(1));
    resetVisitSession();
  }, []);


  useEffect(() => {
    if (!orderDetails || orderDetails?.length === 0) {
      navigate('/');
    }
  }, [orderDetails]);


  if (!orderDetails || orderDetails?.length === 0) return;

  const { cartItems, total } = orderDetails;

  return (
    <section className="checkout-page full-width flex flex-col gap-10 items-center pt-5 md:pt-10">
      <div className="flex flex-col gap-10 contained-width">
        {!isMobile && <Breadcrumbs items={breadcrumbs} />}
        <div className="flex flex-col gap-5 items-center">
          <h2 className="text-center">Thanks for your order!</h2>
          <p className="text-center text-mid mb-0">You will receive order details in your email.</p>
        </div>
      </div>

      <div className="thank-you-container contained-width flex flex-col items-center">
        <div className="order-summary ">
          <div className="order-summary-inner rounded-20">
            <div className="flex flex-col gap-4">
              {cartItems.map((item) => {
                const imageUrl = useLoadDBImage("onProductImages", null, item.id, item.imageId);

                return (
                  <div key={item.cartId} className="cart-item flex flex-col md:flex-row bg-white shadow-md rounded-lg p-4 gap-3 justify-between">
                    <div className="flex flex-col">
                      {item.subscription &&
                        <div className="mb-2">
                          <span className="px-3 py-1 bg-secondary text-white rounded-20">SUBSCRIPTION</span>
                        </div>
                      }
                      <div className="flex flex-col gap-3">
                        <div className="flex items-center gap-2">
                          <p className="text-mid mb-0">{item.name} | <span className="capitalize">{item.tag}</span></p>
                        </div>
                        <div>
                          {item.petType &&
                            <p className="mb-2 capitalize">Pet: {item.petType}</p>
                          }
                          {item.petName &&
                            <p className="mb-2">Name: {item.petName}</p>
                          }
                        </div>
                      </div>
                      <div className="flex items-end flex-1 mt-2">
                        <div className="flex items-center gap-2">
                          <span className="">Quantity:</span>
                          <div className="quantity-controls flex items-center justify-center gap-2 border rounded-lg p-1 min-w-24">
                            <span className="text-lg font-semibold">{item.quantity}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-start">
                      <div className="product-image p-2 box-shadow rounded-10 aspect-square">
                        {imageUrl && <img className="w-full object-cover rounded-8" src={imageUrl} alt="Customized Product" />}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="summary-totals mt-8 flex flex-col">
              <div className="flex justify-between items-start form-title body-heading h4"><span>Total</span><span className="color-primary">${total}</span></div>
            </div>

            <Button variant="filled" className="fit-width mt-8" type="link" link="/">
              Return to the Homepage
            </Button>

          </div>
        </div>
      </div>

    </section>
  );
};

export default ThankYou;
